// extracted by mini-css-extract-plugin
export var text = "_bq-0";